import { CreditSource, CreditType } from 'data/__generated__';

export const CREDIT_TYPE_LABELS = {
    [CreditType.Cash]: 'TotemCash',
    [CreditType.Marketing]: 'Marketing',
    [CreditType.Onboarding]: 'Onboarding',
    [CreditType.Refund]: 'Remboursement',
    [CreditType.TotrouletteReward]: 'Récompense Totroulette',
};

export const CREDIT_SOURCE_LABELS = {
    [CreditSource.TopUp]: 'Recharge client',
    [CreditSource.Csm]: 'CSM (totadmin)',
};
